import React from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

const ContactUs = () => {
  return (
    <>
      <Header />
      <Breadcrumb title="Contact Us" midBreadcrumb="Contact Us" />
      <div className="inner-page cont-main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="mainhead mainhead-center">Contact Us</h2>
              <div className="contact-blk">
                <div className="contactinfo">
                  <div>
                    <h3>Contact Info</h3>
                    <ul className="info">
                      <li>
                        <span>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/location.png"
                            className="img-fluid"
                            alt="Location"
                          />
                        </span>
                        <span>
                          <a
                            href="https://goo.gl/maps/xikBHiomkALzKfVw5"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Mahendragarh, Haryana - 123001
                          </a>
                        </span>
                      </li>
                      <li>
                        <span>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/mail.png"
                            className="img-fluid"
                            alt="Email"
                          />
                        </span>
                        <span>
                          <a
                            href="mailto:matamariamjansevavidyalaya@gmail.com"
                            target="_blank"
                            rel="noreferrer"
                          >
                            matamariamjansevavidyalaya@gmail.com
                          </a>
                        </span>
                      </li>
                      <li>
                        <span>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/call.png"
                            className="img-fluid"
                            alt="Phone"
                          />
                        </span>
                        <span>
                          <a href="tel:01282-260211" target="_blank" rel="noreferrer">
                            01282-260211
                          </a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="contactForm">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3520.2036309880964!2d76.10131461507021!3d28.07933088263921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3912b63e7c70e30b%3A0xcb148c33156d6b98!2sMata%20Mariam%20Jan%20Seva%20Vidyalaya!5e0!3m2!1sen!2sin!4v1647495240243!5m2!1sen!2sin"
                    width="100%"
                    height="100%"
                    title="Mata Mariyam Jan Sewa"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
